<template>
  <div>

    <b-row>
      <b-col md="5">
        <b-form-group
          :label="$t('Email')"
        >
          <b-input-group
            v-if="view===false"
            class="input-group-merge"
          >
            <b-input-group-prepend is-text>
              <feather-icon
                size="16"
                icon="MailIcon"
              />
            </b-input-group-prepend>
            <b-form-input
              v-model="form_sw095[index].sw095s06"
              type="email"
              autocomplete="off"
              inputmode="email"
            />
          </b-input-group>
          <p
            v-else
            class="text-primary mb-0"
          >
            <template v-if="form_sw095[index].sw095s06">
              <b-link :href="`mailto:${form_sw095[index].sw095s06}`">
                <feather-icon
                  size="16"
                  icon="MailIcon"
                  class="mr-1"
                />
                {{ form_sw095[index].sw095s06 }}
              </b-link>
            </template>
            <template v-else>
              -----
            </template>
          </p>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group
          :label="$t('Descritivo')"
        >
          <b-form-input
            v-if="view===false"
            v-model="form_sw095[index].sw095s05"
            type="text"
            autocomplete="off"
          />
          <p
            v-else
            class="text-primary mb-0"
          >
            {{ form_sw095[index].sw095s05 || '-----' }}
          </p>
        </b-form-group>
      </b-col>
      <b-col
        v-if="view===false"
        md="3"
      >
        <div
          class="d-none d-sm-block"
          style="margin-top: 1.95rem"
        />
        <b-button
          v-ripple.400="'rgba(234, 84, 85, 0.15)'"
          variant="outline-danger"
          @click.stop.prevent="removeContactAdditional(index)"
        >
          <feather-icon
            icon="XIcon"
            class="mr-25"
          />
          <span>{{ $t('Eliminar') }}</span>
        </b-button>
      </b-col>
    </b-row>

  </div>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BFormInput, BButton, BInputGroup, BInputGroupPrepend, BLink,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { mapGetters } from 'vuex'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BInputGroup,
    BLink,
    BInputGroupPrepend,
  },
  directives: {
    Ripple,
  },
  props: {
    index: {
      type: Number,
      required: true,
    },
    view: {
      type: Boolean,
      default: () => false,
    },
    removeContactAdditional: {
      type: Function,
      required: true,
    },
  },
  computed:
  {
    ...mapGetters('crm_leads_form', ['form_sw095']),
  },
}
</script>
